// Presentation follows the server-resolved Finance submission mode.
export function getPaymentTerminology(submissionMode = "email") {
  const isEmail = submissionMode !== "intacct_rest";
  const noun = isEmail ? "email" : "packet";
  const nounPlural = `${noun}s`;
  return {
    isEmail, noun, nounPlural,
    formatMessage: message => typeof message === "string" ? message.replace(/\bpayment (?:emails?|packets?)\b/gi, match => {
      const payment = match[0] === "P" ? "Payment" : "payment";
      return `${payment} ${match.toLowerCase().endsWith("s") ? nounPlural : noun}`;
    }) : message,
    singular: `payment ${noun}`, plural: `payment ${nounPlural}`,
    recordTitle: `Payment ${noun}`, title: `Payment ${nounPlural}`,
    identifier: isEmail ? "Email" : "Packet",
    prepare: `Prepare payment ${noun}`, edit: `Edit payment ${noun}`,
    loading: `Loading payment ${nounPlural}`,
    emptyUnsent: `No unsent payment ${nounPlural}.`,
    emptySent: `No sent payment ${nounPlural}.`,
  };
}
